(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duo-pack-picker"]) return;
  try {
    
  (function () {
    class DuoPacker {
      constructor(root) {
        this.root = root;
        this.products = JSON.parse(root.querySelector('[data-duo-products]').textContent || '[]');
        this.tier = null;
        this.slots = [];
        this.activeSlotIndex = null;

        this.tiersEl = root.querySelector('[data-duo-tiers]');
        this.slotsEl = root.querySelector('[data-duo-slots]');
        this.summaryEl = root.querySelector('[data-duo-summary]');
        this.totalEl = root.querySelector('[data-duo-total]');
        this.ctaEl = root.querySelector('[data-duo-cta]');
        this.noteEl = root.querySelector('[data-duo-note]');

        this.modalEl = root.querySelector('[data-duo-modal]');
        this.modalGridEl = root.querySelector('[data-duo-grid]');
        this.modalSearchEl = root.querySelector('[data-duo-search]');

        this.bindTierButtons();
        this.bindModal();
        this.bindCta();
      }

      bindTierButtons() {
        this.tiersEl.querySelectorAll('[data-duo-tier]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const tier = parseInt(btn.getAttribute('data-duo-tier'), 10);
            this.selectTier(tier);
          });
        });
      }

      selectTier(tier) {
        this.tier = tier;
        this.slots = new Array(tier).fill(null);

        this.tiersEl.querySelectorAll('[data-duo-tier]').forEach((btn) => {
          const isActive = parseInt(btn.getAttribute('data-duo-tier'), 10) === tier;
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.slotsEl.hidden = false;
        this.summaryEl.hidden = false;
        this.renderSlots();
        this.updateSummary();
      }

      renderSlots() {
        this.slotsEl.innerHTML = '';
        this.slots.forEach((slot, index) => {
          const wrap = document.createElement('div');
          wrap.className = 'duo-slot' + (slot ? ' duo-slot--filled' : '');

          const box = document.createElement('button');
          box.type = 'button';
          box.className = 'duo-slot__box';

          if (slot) {
            box.disabled = true;
            const img = document.createElement('img');
            img.className = 'duo-slot__image';
            img.src = slot.image;
            img.alt = slot.title;
            box.appendChild(img);

            const remove = document.createElement('span');
            remove.className = 'duo-slot__remove';
            remove.setAttribute('role', 'button');
            remove.setAttribute('tabindex', '0');
            remove.setAttribute('aria-label', 'Retirer ce produit');
            remove.textContent = '×';
            remove.addEventListener('click', (e) => {
              e.stopPropagation();
              this.removeSlot(index);
            });
            box.appendChild(remove);
          } else {
            const plus = document.createElement('span');
            plus.className = 'duo-slot__plus';
            plus.textContent = '+';
            box.appendChild(plus);
            box.addEventListener('click', () => this.openModal(index));
          }

          wrap.appendChild(box);

          const meta = document.createElement('div');
          meta.className = 'duo-slot__meta';
          if (slot) {
            meta.innerHTML =
              '<span class="duo-slot__meta-title">' +
              this.escapeHtml(slot.title) +
              '</span><span class="duo-slot__meta-size">Taille ' +
              this.escapeHtml(slot.sizeTitle) +
              ' · ' +
              this.formatMoney(slot.price) +
              '</span>';
          } else {
            meta.innerHTML = '<span class="duo-slot__meta-size">Emplacement ' + (index + 1) + '</span>';
          }
          wrap.appendChild(meta);

          this.slotsEl.appendChild(wrap);
        });
      }

      removeSlot(index) {
        this.slots[index] = null;
        this.renderSlots();
        this.updateSummary();
      }

      bindModal() {
        this.root.querySelectorAll('[data-duo-modal-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeModal());
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !this.modalEl.hidden) this.closeModal();
        });
        this.modalSearchEl.addEventListener('input', () => this.renderModalGrid());
      }

      openModal(slotIndex) {
        this.activeSlotIndex = slotIndex;
        this.modalSearchEl.value = '';
        this.modalEl.hidden = false;
        this.modalEl.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        this.renderModalGrid();
      }

      closeModal() {
        this.modalEl.hidden = true;
        this.modalEl.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        this.activeSlotIndex = null;
      }

      renderModalGrid() {
        const query = (this.modalSearchEl.value || '').trim().toLowerCase();
        const filtered = this.products.filter((p) => p.title.toLowerCase().includes(query));

        this.modalGridEl.innerHTML = '';

        if (!filtered.length) {
          const empty = document.createElement('div');
          empty.className = 'duo-modal__empty';
          empty.textContent = 'Aucun produit trouvé.';
          this.modalGridEl.appendChild(empty);
          return;
        }

        filtered.forEach((product) => {
          const hasAvailable = product.variants.some((v) => v.available);
          const card = document.createElement('div');
          card.className = 'duo-modal-card';
          if (!hasAvailable) card.setAttribute('data-unavailable', 'true');

          const imageWrap = document.createElement('div');
          imageWrap.className = 'duo-modal-card__image-wrap';
          const img = document.createElement('img');
          img.className = 'duo-modal-card__image';
          img.loading = 'lazy';
          img.src = product.image;
          img.alt = product.title;
          imageWrap.appendChild(img);
          card.appendChild(imageWrap);

          const body = document.createElement('div');
          body.className = 'duo-modal-card__body';

          const title = document.createElement('div');
          title.className = 'duo-modal-card__title';
          title.textContent = product.title;
          body.appendChild(title);

          const price = document.createElement('div');
          price.className = 'duo-modal-card__price';
          price.textContent = this.formatMoney(product.variants[0] ? product.variants[0].price : 0);
          body.appendChild(price);

          const select = document.createElement('select');
          select.className = 'duo-modal-card__select';
          select.disabled = !hasAvailable;
          product.variants.forEach((variant) => {
            const opt = document.createElement('option');
            opt.value = variant.id;
            opt.textContent = variant.available ? variant.title : variant.title + ' (épuisé)';
            opt.disabled = !variant.available;
            select.appendChild(opt);
          });
          body.appendChild(select);

          select.addEventListener('change', () => {
            const variant = product.variants.find((v) => String(v.id) === select.value);
            if (variant) price.textContent = this.formatMoney(variant.price);
          });

          const confirmBtn = document.createElement('button');
          confirmBtn.type = 'button';
          confirmBtn.className = 'button button-secondary duo-modal-card__confirm';
          confirmBtn.textContent = 'Choisir';
          confirmBtn.disabled = !hasAvailable;
          confirmBtn.addEventListener('click', () => {
            const variant = product.variants.find((v) => String(v.id) === select.value);
            if (!variant || !variant.available) return;
            this.confirmSlot(product, variant);
          });
          body.appendChild(confirmBtn);

          card.appendChild(body);
          this.modalGridEl.appendChild(card);
        });
      }

      confirmSlot(product, variant) {
        if (this.activeSlotIndex === null) return;
        this.slots[this.activeSlotIndex] = {
          productId: product.id,
          variantId: variant.id,
          title: product.title,
          image: product.image,
          sizeTitle: variant.title,
          price: variant.price,
        };
        this.closeModal();
        this.renderSlots();
        this.updateSummary();
      }

      updateSummary() {
        const filled = this.slots.filter(Boolean);
        const remaining = this.slots.length - filled.length;

        if (remaining > 0) {
          this.ctaEl.disabled = true;
          this.ctaEl.textContent =
            'Sélectionnez ' + remaining + ' produit' + (remaining > 1 ? 's' : '');
          this.totalEl.textContent = '—';
          return;
        }

        const prices = filled.map((s) => s.price);
        const sum = prices.reduce((a, b) => a + b, 0);
        const cheapest = Math.min.apply(null, prices);
        const discount = this.tier === 3 ? cheapest : Math.round(cheapest * 0.5);
        const total = sum - discount;

        this.totalEl.textContent = this.formatMoney(total);
        this.ctaEl.disabled = false;
        this.ctaEl.textContent = 'Ajouter au panier — Total : ' + this.formatMoney(total);
      }

      bindCta() {
        this.ctaEl.addEventListener('click', () => this.addAllToCart());
      }

      async addAllToCart() {
        const filled = this.slots.filter(Boolean);
        if (filled.length !== this.slots.length || !filled.length) return;

        this.ctaEl.disabled = true;
        const originalText = this.ctaEl.textContent;
        this.ctaEl.textContent = 'Ajout en cours…';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: filled.map((slot) => ({ id: slot.variantId, quantity: 1 })),
            }),
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data && data.description ? data.description : 'Erreur lors de l\'ajout au panier');
          }

          if (this.noteEl) {
            this.noteEl.hidden = false;
          }

          window.location.href = '/cart';
        } catch (err) {
          this.ctaEl.disabled = false;
          this.ctaEl.textContent = originalText;
          window.alert(
            'Un produit sélectionné n\'est plus disponible. Merci de modifier votre pack et réessayer.'
          );
        }
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return amount.replace('.', ',') + ' dh';
      }

      escapeHtml(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      }
    }

    function init() {
      document.querySelectorAll('[data-duo-picker]').forEach((root) => {
        if (root.__duoPackerInit) return;
        root.__duoPackerInit = true;
        new DuoPacker(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duo-pack-summary"]) return;
  try {
    
  (function () {
    /**
     * pack.tier: 2 | 3 | null
     * pack.slots: Array<null | {productId, variantId, price, title, size, image}>
     *
     * "2 Jeans" is pre-selected by default so the slot tray is visible as
     * soon as the page loads, matching the tier card's initial highlighted
     * state below.
     */
    const pack = { tier: 2, slots: new Array(2).fill(null) };

    function getRoot() {
      return document.querySelector('[data-duo-tier-area]');
    }

    function getCollectionMain() {
      return document.querySelector('[data-template="collection.offre-duo"]');
    }

    function formatMoney(cents) {
      const root = getRoot();
      const moneyFormat = (root && root.dataset.moneyFormat) || '{{ amount }}';
      const currencyCode = (root && root.dataset.currency) || 'MAD';

      if (window.__duoFormatMoney) return window.__duoFormatMoney(cents, moneyFormat, currencyCode);
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + currencyCode;
    }

    import('@theme/money-formatting')
      .then((mod) => {
        window.__duoFormatMoney = mod.formatMoney;
      })
      .catch(() => {});

    function computeSummary() {
      const items = pack.slots.filter(Boolean);
      const count = items.length;
      const sum = items.reduce((total, item) => total + item.price, 0);

      if (pack.tier && count === pack.tier) {
        const cheapest = Math.min.apply(
          null,
          items.map((i) => i.price)
        );
        if (pack.tier === 2) {
          return { count, total: sum - Math.round(cheapest * 0.5), label: '-50% sur le moins cher appliqué', complete: true };
        }
        return { count, total: sum - cheapest, label: 'La pièce la moins chère offerte', complete: true };
      }

      return { count, total: sum, label: null, complete: false };
    }

    function renderTiers() {
      const root = getRoot();
      if (!root) return;
      root.querySelectorAll('[data-duo-tier]').forEach((btn) => {
        const tierValue = parseInt(btn.getAttribute('data-duo-tier'), 10);
        btn.setAttribute('aria-pressed', tierValue === pack.tier ? 'true' : 'false');
      });
    }

    function renderSlots() {
      const root = getRoot();
      if (!root) return;
      const slotsEl = root.querySelector('[data-duo-slots]');
      if (!slotsEl) return;

      if (!pack.tier) {
        slotsEl.hidden = true;
        slotsEl.innerHTML = '';
        return;
      }

      slotsEl.hidden = false;
      slotsEl.innerHTML = '';

      pack.slots.forEach((slot, index) => {
        const wrap = document.createElement('div');
        wrap.className = 'duo-slot' + (slot ? ' duo-slot--filled' : '');

        const box = document.createElement('div');
        box.className = 'duo-slot__box';

        if (slot) {
          const img = document.createElement('img');
          img.className = 'duo-slot__image';
          img.src = slot.image;
          img.alt = slot.title;
          img.loading = 'lazy';
          box.appendChild(img);

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'duo-slot__remove';
          remove.setAttribute('aria-label', 'Retirer ce produit');
          remove.textContent = '×';
          remove.addEventListener('click', () => removeSlot(index));
          box.appendChild(remove);
        } else {
          const idx = document.createElement('span');
          idx.className = 'duo-slot__index';
          idx.textContent = 'Jean ' + (index + 1);
          box.appendChild(idx);
        }

        wrap.appendChild(box);

        const meta = document.createElement('div');
        meta.className = 'duo-slot__meta';
        if (slot) {
          const titleSpan = document.createElement('span');
          titleSpan.className = 'duo-slot__meta-title';
          titleSpan.textContent = slot.title;
          const sizeSpan = document.createElement('span');
          sizeSpan.className = 'duo-slot__meta-size';
          sizeSpan.textContent = 'Taille ' + slot.size;
          meta.appendChild(titleSpan);
          meta.appendChild(sizeSpan);
        }
        wrap.appendChild(meta);

        slotsEl.appendChild(wrap);
      });
    }

    function renderSummary() {
      const root = getRoot();
      if (!root) return;
      const summaryEl = root.querySelector('[data-duo-summary]');
      const totalEl = root.querySelector('[data-duo-total]');
      const codBtn = root.querySelector('[data-duo-cod]');
      const noteEl = root.querySelector('[data-duo-note]');
      if (!summaryEl) return;

      const summary = computeSummary();

      if (!pack.tier || summary.count === 0) {
        summaryEl.hidden = true;
        codBtn.disabled = true;
        return;
      }

      summaryEl.hidden = false;
      totalEl.textContent = formatMoney(summary.total);
      codBtn.disabled = !summary.complete;

      const collectionMain = getCollectionMain();
      const isFull = summary.complete;
      if (collectionMain) {
        collectionMain.setAttribute('data-duo-full', isFull ? 'true' : 'false');
      }
      if (noteEl) noteEl.hidden = !isFull;
    }

    function render() {
      renderTiers();
      renderSlots();
      renderSummary();
    }

    function setCardState(productId, chosen) {
      const card = document.querySelector('product-card[data-product-id="' + productId + '"]');
      if (card) card.classList.toggle('duo-card-selected', chosen);

      const button = document.querySelector('[data-duo-choose][data-product-id="' + productId + '"]');
      if (button) {
        button.dataset.chosen = chosen ? 'true' : 'false';
        const label = button.querySelector('[data-duo-choose-label]');
        if (label) label.textContent = chosen ? 'Ajouté ✓' : 'Choisir';
      }
    }

    function findSlotIndexForProduct(productId) {
      return pack.slots.findIndex((slot) => slot && slot.productId === productId);
    }

    function selectTier(tier) {
      // Changing tiers resets any in-progress pack to avoid inconsistent state.
      pack.slots.forEach((slot) => {
        if (slot) setCardState(slot.productId, false);
      });

      pack.tier = tier;
      pack.slots = new Array(tier).fill(null);

      const collectionMain = getCollectionMain();
      if (collectionMain) collectionMain.setAttribute('data-duo-full', 'false');

      render();
    }

    function removeSlot(index) {
      const slot = pack.slots[index];
      if (!slot) return;
      setCardState(slot.productId, false);
      pack.slots[index] = null;
      render();
    }

    function handleChoose(button) {
      const productId = button.getAttribute('data-product-id');
      if (!productId) return;

      const existingIndex = findSlotIndexForProduct(productId);
      if (existingIndex !== -1) {
        removeSlot(existingIndex);
        return;
      }

      if (!pack.tier) {
        window.alert('Merci de choisir une formule (2 Jeans ou 3 Jeans) en haut de la page.');
        return;
      }

      const openIndex = pack.slots.findIndex((slot) => slot === null);
      if (openIndex === -1) {
        // Pack already full — the CSS rule normally prevents this click, this
        // is a safety net for keyboard / assistive-tech activation.
        return;
      }

      const card = button.closest('[data-duo-card]');
      const select = card ? card.querySelector('[data-duo-size]') : null;
      const option = select ? select.selectedOptions[0] : null;

      if (!select || !option || option.disabled) {
        window.alert('Merci de choisir une taille disponible.');
        return;
      }

      pack.slots[openIndex] = {
        productId: productId,
        variantId: option.value,
        price: parseInt(option.getAttribute('data-price'), 10) || 0,
        title: button.getAttribute('data-product-title') || '',
        size: option.textContent.trim(),
        image: button.getAttribute('data-product-image') || '',
      };

      setCardState(productId, true);
      render();
    }

    async function finalizeCod(cta) {
      const items = pack.slots.filter(Boolean);
      if (!pack.tier || items.length !== pack.tier) return;

      const originalHtml = cta.innerHTML;
      const label = cta.querySelector('[data-duo-cod-label]');
      cta.disabled = true;
      if (label) label.textContent = 'Préparation…';

      try {
        await fetch(Theme.routes.cart_add_url.replace('/add.js', '/clear.js'), { method: 'POST' });

        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items.map((item) => ({ id: Number(item.variantId), quantity: 1 })),
          }),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error((data && (data.description || data.message)) || 'Erreur lors de l\'ajout au panier');
        }

        const easysellButton = document.querySelector('.es-popup-button-product, .es-popup-button');
        if (easysellButton) {
          easysellButton.click();
        } else {
          window.alert(
            'Votre pack a été ajouté au panier, mais le bouton de commande n\'a pas pu être trouvé. Merci de réessayer.'
          );
        }
      } catch (err) {
        window.alert('Un des articles sélectionnés n\'est plus disponible. Merci de modifier votre pack et réessayer.');
      } finally {
        cta.disabled = false;
        cta.innerHTML = originalHtml;
      }
    }

    document.addEventListener('click', function (event) {
      const tierButton = event.target.closest && event.target.closest('[data-duo-tier]');
      if (tierButton) {
        selectTier(parseInt(tierButton.getAttribute('data-duo-tier'), 10));
        return;
      }

      const chooseButton = event.target.closest && event.target.closest('[data-duo-choose]');
      if (chooseButton && !chooseButton.disabled) {
        handleChoose(chooseButton);
        return;
      }

      const codButton = event.target.closest && event.target.closest('[data-duo-cod]');
      if (codButton && !codButton.disabled) {
        finalizeCod(codButton);
      }
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
